<template>
  <div class="ws_top">
    <div class="welcome">{{ mobile ? "链通支付平合" : "你好，欢迎访问链通支付平合！" }}</div>
    <div class="stat">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="amount" style="color:#2dd122">{{ dayIncomeTotal }}</div>
          <div class="name day">日总入款</div>
          <div class="amount" style="color:#2dd122">{{ monthIncomeTotal }}</div>
          <div class="name">月总入款</div>
        </el-col>
        <el-col :span="6">
          <div>
            <div class="amount">{{ dayIncomeUsdtTotal }}</div>
            <div class="name day">日应下发</div>
            <div class="amount">{{ monthIncomeUsdtTotal }}</div>
            <div class="name">月应下发</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <div class="amount">{{ dayPayoutTotal }}</div>
            <div class="name day">日已下发</div>
            <div class="amount">{{ monthPayoutTotal }}</div>
            <div class="name">月已下发</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <div class="amount">{{ dayUnPayoutTotal }}</div>
            <div class="name day">日未下发</div>
            <div class="amount">{{ monthUnPayoutTotal }}</div>
            <div class="name">月未下发</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { statTotal } from '@/api/otc/group'

export default {
  name: 'OtcTop',
  data () {
    return {
      monthIncomeTotal: 0.00,
      monthIncomeUsdtTotal: 0.00,
      monthPayoutTotal: 0.00,
      monthUnPayoutTotal: 0.00,
      dayIncomeTotal: 0.00,
      dayIncomeUsdtTotal: 0.00,
      dayPayoutTotal: 0.00,
      dayUnPayoutTotal: 0.00
    }
  },
  created () {
    this.getStatTotal()
  },
  computed: {
    mobile () {
      return this.$store.state.app.device === 'mobile'
    }
  },
  methods: {
    getStatTotal () {
      statTotal({}).then(response => {
        this.monthIncomeTotal = parseFloat(response.data.monthIncomeTotal).toLocaleString()
        this.monthIncomeUsdtTotal = parseFloat(response.data.monthIncomeUsdtTotal).toLocaleString()
        this.monthPayoutTotal = parseFloat(Math.abs(response.data.monthPayoutTotal)).toLocaleString()
        this.monthUnPayoutTotal = parseFloat(response.data.monthUnPayoutTotal).toLocaleString()
        this.dayIncomeTotal = parseFloat(response.data.dayIncomeTotal).toLocaleString()
        this.dayIncomeUsdtTotal = parseFloat(response.data.dayIncomeUsdtTotal).toLocaleString()
        this.dayPayoutTotal = parseFloat(Math.abs(response.data.dayPayoutTotal)).toLocaleString()
        this.dayUnPayoutTotal = parseFloat(response.data.dayUnPayoutTotal).toLocaleString()
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
  .ws_top {
    height:280px;
    overflow-y: hidden;
    background: url('/static/images/top_ws.png') center center/cover no-repeat;
  }
  .welcome {
    margin: 30px 30px;
    font-size:32px;
    font-weight: bolder;
    font-family: "黑体";
    color: white;
  }
  .stat {
    width: 900px;
    color:white;
    margin-left: 30px;
  }
  .amount {
    font-size:26px;
    font-weight: bolder;
    text-align: center;
    font-family: "黑体";
  }
  .name {
    font-size:16px;
    text-align: center;
    margin-top: 10px;
  }
  .day {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/OtcTop.vue